import styled from "styled-components";

export const StyledExchangeProfitWrapper = styled.div`
  .exchange-profit-stabling-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 175px max-content;
    grid-gap: 20px;
    
    @media screen and (max-width: 992px) {
      grid-template-columns: 100%;
    }

    .sum-of-profit-info {
      display: flex;
      flex-direction: column;

      &__text {
        color: ${({theme}) => theme.text.primary};
        font-weight: 600;
        padding: 4px 0;
      }
    }
  }
  
  .profit-list-table_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }

  .profit-list-table {
    &__head, &__row {
      grid-template-columns: repeat(2, minmax(250px, .85fr)) repeat(7, minmax(150px, 1fr));
    }

    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }
      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};
        & > div {
          padding-top: 20px;
          &:before {
            display: block;
          }
        }
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
    }
  }
`;



export const StyledExchangeProfitDetails = styled.div`
  .content-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content max-content 175px;
    grid-gap: 20px;

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }

  .profit-details-list_scroll {
    @media screen and (max-width: 992px) {
      overflow: inherit;
    }
  }

  .profit-details-list {
    &__head, &__row {
      grid-template-columns: repeat(2, minmax(290px, .85fr)) repeat(6, minmax(150px, 1fr));
    }

    @media screen and (max-width: 992px) {
      min-width: auto;
      overflow-x: inherit;
      &__head {
        display: none;
      }

      &__row {
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr);
        border: 1px solid ${({theme}) => theme.surface.border};

        & > div {
          padding-top: 20px;

          &:before {
            display: block;
          }
        }
      }
    }
    @media screen and (max-width: 599px) {
      &__row {
        padding: 15px 10px;
        grid-template-columns: 100%;
      }
    }
  }
`;